"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CBAThemeContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _defaultBrandContext = require("../../defaults/defaultBrandContext");
var _handlers = require("../../handlers/handlers");
var _cbaContactStatement = require("./cbaContactStatement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable max-len */
var brandFullName = 'Commonwealth Bank of Australia';
var brandTitle = 'CBA';
var brandShortName = 'CBA';
var brandSupportPhoneNumber = '1300 913 575';
var petSurePhoneNumber = '(02) 9842 4800';
var CBAThemeContext = exports.CBAThemeContext = _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext), {}, {
  brand: {
    key: 'cba',
    title: brandTitle,
    fullName: brandFullName,
    shortName: brandShortName,
    products: 'cba',
    homeUrl: 'https://www.commbank.com.au/insurance/pet-insurance.html',
    cssUrls: null,
    logos: [{
      key: 'commBankLogo',
      imageUrl: 'https://www.commbank.com.au/content/dam/commbank/commBank-logo.svg',
      redirectUrl: '/',
      imageTitle: 'Get a pet insurance quote',
      imageTitleDescription: 'Provided by PetSure - Australia\'s leading Pet Insurance provider',
      imageTitleDescriptionMobile: 'Provided by PetSure'
    }],
    supportPhoneNumber: brandSupportPhoneNumber,
    supportEmailAddress: 'cba@petsure.com.au',
    partner: 'CBA',
    marketingPartner: 'PetSure',
    broker: 'CBA',
    styleSheet: 'cba',
    favIconUrl: 'https://www.commbank.com.au/etc/designs/commbank-neo/favicon.ico',
    partnerPrefix: 'CB',
    gtmId: 'NZXSJQTS',
    gtmDataLayer: 'dataLayer',
    contactStatementLogo: 'provided_By_Petsure_Logo_CMYK_Black.png'
  },
  promos: {
    staffPromos: ['CBASTAFF'],
    // TODO: We can extend emailDomainPromos to be an array if the brand requires priority based
    // promo application or requires different promos based on email domains.
    emailDomainPromos: {
      promoCode: 'CBASTAFF',
      emailDomains: ['cba.com.au', 'bankwest.com.au']
    }
  },
  seo: {
    title: 'Pet Insurance',
    description: 'Get a pet insurance quote online for comprehensive cover for dogs and cats. Visit any vet in Australia and add dental and routine care, like desexing.'
  },
  contactStatement: function contactStatement(contactStatementLogoUrl) {
    return (0, _cbaContactStatement.coBrandContactStatement)(contactStatementLogoUrl, brandFullName, brandSupportPhoneNumber, petSurePhoneNumber, 'Continue to cover options');
  },
  privacyCollectionNotice: function privacyCollectionNotice(contactStatementLogoUrl) {
    return (0, _cbaContactStatement.coBrandPrivacyCollectionNotice)(contactStatementLogoUrl, brandFullName, brandSupportPhoneNumber, petSurePhoneNumber, 'Continue to summary', CBAThemeContext.brand.supportEmailAddress);
  },
  layout: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout), {}, {
    header: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.header), {}, {
      contactDetails: /*#__PURE__*/_react["default"].createElement("aside", {
        className: "contactDetails"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "41px",
        height: "40px",
        viewBox: "0 0 41 40",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M26.167 5H14.8337C13.3609 5 12.167 6.19391 12.167 7.66667V32.3333C12.167 33.8061 13.3609 35 14.8337 35H26.167C27.6398 35 28.8337 33.8061 28.8337 32.3333V7.66667C28.8337 6.19391 27.6398 5 26.167 5Z",
        fill: "white",
        stroke: "#1E1E1E"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M12.167 30.7144H28.8337V32.3334C28.8337 33.8062 27.6398 35.0001 26.167 35.0001H14.8337C13.3609 35.0001 12.167 33.8062 12.167 32.3334V30.7144Z",
        fill: "#FAEC20",
        stroke: "#1E1E1E"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M18.3262 7.14258H23.3986",
        stroke: "#1E1E1E"
      }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel://1300913575"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Need help?"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, "Call us on "), /*#__PURE__*/_react["default"].createElement("span", null, "1300 913 575"))))
    }),
    footer: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.footer), {}, {
      socialLinks: null,
      customDisclosure: {
        brand: {
          label: 'Commonwealth Bank of Australia'
        },
        tmd: {
          link: 'https://www.commbank.com.au/insurance/brochures-forms.html',
          label: 'www.commbank.com.au/insurance/brochures-forms.html'
        },
        vetChatTAndC: {
          link: 'https://cbainsurance.vetchat.com.au/terms-and-conditions',
          label: 'cbainsurance.vetchat.com.au/terms-and-conditions'
        },
        vetChatSignUp: {
          link: 'https://cbainsurance.vetchat.com.au/signup',
          label: 'cbainsurance.vetchat.com.au/signup'
        },
        authorisedRepresentative: 'Commonwealth Bank of Australia ABN 48 123 123 124, AFSL 234945 (CBA)',
        footerDisclaimer: function footerDisclaimer(props) {
          return /*#__PURE__*/_react["default"].createElement("p", null, "This policy is issued by PetSure (Australia) Pty Ltd ABN 95 075 949 923, AFSL 420183 (PetSure) and promoted and distributed by Commonwealth Bank of Australia ABN 48 123 123 124, AFSL 234945 (CBA). Any advice provided is general only and does not take into account your individual objectives, financial situation or needs. Please consider the Product Disclosure Statement (PDS) to ensure this product meets your needs before purchasing. PDS and Target Market Determination available at ", /*#__PURE__*/_react["default"].createElement("a", {
            target: "_blank",
            rel: "noreferrer",
            href: props.tmd.link,
            ref: props.disclaimerLink
          }, props.tmd.label), ".");
        },
        hasGapOnly: true,
        myPetPass: {
          hasMyPetPass: true,
          eligibilityWordings: 'Available only to holders of active Pet Insurance policies distributed by CBA'
        }
      },
      footerSections: null,
      copyright: null,
      customContent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "customFooterContent"
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: "policy"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://petsure.com.au/privacy-policy/",
        target: "_blank",
        rel: "noreferrer"
      }, "Privacy Policy"), " | View the ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.commbank.com.au/insurance/brochures-forms.html",
        target: "_blank",
        rel: "noreferrer"
      }, "PDS and TMD")), /*#__PURE__*/_react["default"].createElement("section", {
        className: "footerContact"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "41px",
        height: "40px",
        viewBox: "0 0 41 40",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M26.167 5H14.8337C13.3609 5 12.167 6.19391 12.167 7.66667V32.3333C12.167 33.8061 13.3609 35 14.8337 35H26.167C27.6398 35 28.8337 33.8061 28.8337 32.3333V7.66667C28.8337 6.19391 27.6398 5 26.167 5Z",
        fill: "white",
        stroke: "#1E1E1E"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M12.167 30.7144H28.8337V32.3334C28.8337 33.8062 27.6398 35.0001 26.167 35.0001H14.8337C13.3609 35.0001 12.167 33.8062 12.167 32.3334V30.7144Z",
        fill: "#FAEC20",
        stroke: "#1E1E1E"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M18.3262 7.14258H23.3986",
        stroke: "#1E1E1E"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "footerContactDetails"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel://1300913575"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Need help?"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, "Call us on "), /*#__PURE__*/_react["default"].createElement("span", null, "1300 913 575")))))
    }),
    aside: {
      campaigns: function campaigns() {
        var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          promoCode: ''
        };
        var staffPromoCode = CBAThemeContext.promos.staffPromos;
        var campaigns = [/*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
          key: "CBACampaign1",
          customCssClass: "CBACampaign1",
          campaignImageDescription: "Get two months free Pet Insurance.",
          campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
          campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
            return "".concat(campaignBaseUrl, "/cba/CBA_promo_tile.png");
          },
          __type: "CampaignHolder"
        }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
          key: "CBACampaign2",
          customCssClass: "CBACampaign2",
          campaignImageDescription: "myPetPass logo",
          campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
          campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
            return "".concat(campaignBaseUrl, "/Common/MyPetPass_QT_tile_464x400.png");
          },
          __type: "CampaignHolder"
        }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
          key: "CBACampaign4",
          customCssClass: "CBACampaign4",
          campaignImageDescription: "GapOnly ready Pet Insurance",
          campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
          campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
            return "".concat(campaignBaseUrl, "/Common/GapOnly_tile_232x200.png");
          },
          __type: "CampaignHolder"
        })];
        return (0, _handlers.getVisibleCampaignHolders)(staffPromoCode, context.promoCode, campaigns);
      }
    }
  })
});
var _default = exports["default"] = {
  CBAThemeContext: CBAThemeContext
};